/**
 * quickshop-rfq.js — 773 Group LLC
 * Replaces Add to Cart / Buy it now in Empire Quick Shop popup with RFQ form.
 * Uses polling to handle Empire's AJAX-loaded popup content.
 */

(function () {

  var STYLES = `
    .qs-rfq-wrap {
      margin-top: 16px;
      border-top: 1px solid #eee;
      padding-top: 16px;
    }
    .qs-rfq-heading {
      font-size: 13px;
      font-weight: 700;
      color: #1A1F3C;
      margin-bottom: 12px;
    }
    .qs-rfq-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
      margin-bottom: 10px;
    }
    .qs-rfq-field { margin-bottom: 10px; }
    .qs-rfq-input {
      width: 100%;
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 10px 12px;
      font-size: 13px;
      font-family: inherit;
      color: #1D1D1D;
      background: #fff;
      outline: none;
      box-sizing: border-box;
      transition: border-color 0.15s;
    }
    .qs-rfq-input:focus { border-color: #046E82; }
    .qs-rfq-input::placeholder { color: #aaa; }
    .qs-rfq-textarea { min-height: 80px; resize: vertical; }
    .qs-rfq-btn {
      width: 100%;
      background: #F04F36;
      color: #fff;
      border: none;
      padding: 11px 20px;
      font-size: 13px;
      font-weight: 700;
      border-radius: 4px;
      cursor: pointer;
      font-family: inherit;
      transition: background 0.15s;
    }
    .qs-rfq-btn:hover { background: #d43a22; }
    .qs-rfq-note {
      font-size: 11px;
      color: #888;
      margin-top: 8px;
      text-align: center;
      line-height: 1.5;
    }
  `;

  function injectStyles() {
    if (document.getElementById('qs-rfq-styles')) return;
    var el = document.createElement('style');
    el.id = 'qs-rfq-styles';
    el.textContent = STYLES;
    document.head.appendChild(el);
  }

  function escHtml(str) {
    return String(str || '')
      .replace(/&/g,'&amp;').replace(/</g,'&lt;')
      .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function injectRFQ(container) {
    if (container.querySelector('.qs-rfq-wrap')) return;

    var hideSelectors = [
      '.product-form',
      '[data-product-form]',
      '.product-form__submit-group',
      '.product-form__cart-submit',
      '.shopify-payment-button',
      '[data-shopify="payment-button"]',
      '.quantity-selector',
      '[data-product-quantity-input]',
      '.product-form__quantity',
      '.product-form__controls-group--submit'
    ];

    hideSelectors.forEach(function(sel) {
      container.querySelectorAll(sel).forEach(function(el) {
        el.style.setProperty('display', 'none', 'important');
      });
    });

    var titleEl  = container.querySelector('.productitem--title a, [data-product-title], h2.modal__title, h2, h3');
    var skuEl    = container.querySelector('[data-product-sku] .product-sku__number, [data-product-sku], .product-sku');
    var vendorEl = container.querySelector('[data-product-vendor], .productitem--vendor, .product-vendor');

    var title  = titleEl  ? titleEl.textContent.trim()  : '';
    var sku    = skuEl    ? skuEl.textContent.trim().replace(/^SKU[:\s]*/i,'') : '';
    var vendor = vendorEl ? vendorEl.textContent.trim() : '';
    var hiddenVal = title + (sku ? ' — SKU: ' + sku : '') + (vendor ? ' — ' + vendor : '');

    var div = document.createElement('div');
    div.className = 'qs-rfq-wrap';
    div.innerHTML =
      '<div class="qs-rfq-heading">Request a Quote</div>' +
      '<form class="qs-rfq-form" action="/contact" method="post" accept-charset="UTF-8">' +
        '<input type="hidden" name="form_type" value="contact">' +
        '<input type="hidden" name="utf8" value="&#x2713;">' +
        '<input type="hidden" name="contact[product]" value="' + escHtml(hiddenVal) + '">' +
        '<input type="hidden" name="redirect" value="/pages/quote-received">' +
        '<div class="qs-rfq-row">' +
          '<input class="qs-rfq-input" type="text" name="contact[name]" placeholder="Name *" required>' +
          '<input class="qs-rfq-input" type="email" name="contact[email]" placeholder="Email *" required>' +
        '</div>' +
        '<div class="qs-rfq-row">' +
          '<input class="qs-rfq-input" type="text" name="contact[company]" placeholder="Company Name">' +
          '<input class="qs-rfq-input" type="number" name="contact[quantity]" placeholder="Quantity" min="1">' +
        '</div>' +
        '<div class="qs-rfq-field">' +
          '<textarea class="qs-rfq-input qs-rfq-textarea" name="contact[message]" placeholder="Message (optional)"></textarea>' +
        '</div>' +
        '<button class="qs-rfq-btn" type="submit">Request Quote</button>' +
        '<p class="qs-rfq-note">Part: <strong>' + escHtml(title) + '</strong>' +
          (sku ? ' &nbsp;|&nbsp; SKU: <strong>' + escHtml(sku) + '</strong>' : '') + '</p>' +
      '</form>';

    var insertAfter = container.querySelector('[data-product-sku], .product-sku')
      || container.querySelector('[data-product-price], .product-pricing, .price')
      || container.querySelector('[data-product-description]');

    if (insertAfter && insertAfter.parentNode) {
      insertAfter.parentNode.insertBefore(div, insertAfter.nextSibling);
    } else {
      container.appendChild(div);
    }
  }

  function pollForQuickShop(container, attempts) {
    attempts = attempts || 0;
    if (attempts > 40) return;
    var inner = container.querySelector('.productitem--info, .product-details, [data-product-title], h2, h3');
    if (inner) {
      injectRFQ(container);
    } else {
      setTimeout(function() { pollForQuickShop(container, attempts + 1); }, 100);
    }
  }

  function init() {
    injectStyles();

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('productitem-quickshop')) {
            pollForQuickShop(node, 0);
          }
          var qs = node.querySelector('.productitem-quickshop, [data-product-quickshop]');
          if (qs) pollForQuickShop(qs, 0);
          if (node.classList && (node.classList.contains('modal__inner') || node.classList.contains('modal__content'))) {
            pollForQuickShop(node, 0);
          }
        });

        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          var t = mutation.target;
          if (t.classList.contains('modal--active') || t.classList.contains('modal--open') || t.classList.contains('is-visible')) {
            var inner = t.querySelector('.productitem-quickshop, [data-product-quickshop]');
            if (inner) pollForQuickShop(inner, 0);
          }
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    document.body.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-product-quickshop-trigger], .quick-shop-trigger, [data-quick-shop]');
      if (!btn) return;
      setTimeout(function() {
        var container = document.querySelector('.productitem-quickshop, .modal--quickshop .modal__inner, [data-product-quickshop]');
        if (container) pollForQuickShop(container, 0);
      }, 300);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
